import { useLocation } from 'react-router-dom';

export const SUPPORTED_PREFIXED_LANGS = ['en', 'es', 'it'] as const;

export type PrefixedLang = (typeof SUPPORTED_PREFIXED_LANGS)[number];
export type Lang = 'fr' | PrefixedLang;

export const getLangFromPathname = (pathname: string): Lang => {
  const segment = pathname.split('/')[1];
  if ((SUPPORTED_PREFIXED_LANGS as readonly string[]).includes(segment)) {
    return segment as PrefixedLang;
  }
  return 'fr';
};

export const useLang = (): Lang => {
  const { pathname } = useLocation();
  return getLangFromPathname(pathname);
};
